export default "__VITE_ASSET__576e73e6__"